class UrlsService {
    public login(): string {
        return "/login"
    }

    public app(): string {
        return "/"
    }

    public tasks(): string {
        return "/tasks"
    }

    public createTask(): string {
        return "/create"
    }

    public editTask(id: string = ":id"): string {
        return `/edit/${id}`
    }
}

const urlsService: UrlsService = new UrlsService()

export {urlsService}